import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-494b269c")

_pushScopeId("data-v-494b269c")
const _hoisted_1 = {
  key: 0,
  type: "button",
  class: "button is-primary is-small"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("td", null, [
    (_ctx.isRenewable)
      ? (_openBlock(), _createBlock("button", _hoisted_1, " Renew "))
      : _createCommentVNode("", true)
  ]))
})